import { Box } from '@mui/material'
import { Screens, useFormContext } from '../../context/FormContext'
import AboutScreen from '../../screens/AboutScreen'
import CertificatesScreen from '../../screens/CertificatesScreen'
import LanguagesScreen from '../../screens/LanguagesScreen'
import PositionScreen from '../../screens/PositionScreen'
import SkillsScreen from '../../screens/SkillsScreen'
import MobileStepper from '@mui/material/MobileStepper'
import { useRootDivContext } from '../../context/RootDivContext'

const screensMap = {
    [Screens.ABOUT]: <AboutScreen />,
    [Screens.POSITION]: <PositionScreen />,
    [Screens.LANGUAEGS]: <LanguagesScreen />,
    [Screens.CERTIFICATES]: <CertificatesScreen />,
    [Screens.SKILLS]: <SkillsScreen />,
}


const JobApplicationForm = () => {

    const {
        currentScreen, goToNextScreen, goToPreviousScreen, formik, labels
    } = useFormContext()

    const { isOpened, setIsOpened } = useRootDivContext()

    return (
    <div className={`react-job-application-form ${isOpened ? '' : 'hidden'}`}>
        <Box className='form-container' sx={{width: '100%'}}>
            <MobileStepper
                variant="progress"
                steps={Object.keys(Screens).length / 2}
                activeStep={currentScreen}
                nextButton={
                    <button className='stepper-button next' onClick={goToNextScreen}>
                        {labels.general.next}
                    </button>
                }
                backButton={
                    <button className='stepper-button back' onClick={goToPreviousScreen}>
                        {labels.general.back}
                    </button>
                }
                sx={{ width: '100%', position: 'unset', background: 'var(--warmwhite)', px: 0, pt: 0, pb: '32px',
                      '@media (min-width: 1024px)': {
                        pb: '48px',
                      }, }}
            />
            {screensMap[currentScreen]}
            <Box sx={{width: '100%', marginTop: 'auto', display: 'flex', justifyContent: 'flex-end'}}>
                <button
                    className="react-form-button cancel"
                    type="button"
                        onClick={() => { setIsOpened(false) }}>
                    {labels.general.cancel}
                </button>
                <button
                    className="react-form-button"
                    type={currentScreen === (Object.keys(Screens).length / 2 - 1) ? 'submit' : 'button'}
                    onClick={() => { if (currentScreen === Screens.SKILLS) { formik?.submitForm() } else { goToNextScreen() } }}>
                    {currentScreen === (Object.keys(Screens).length / 2 - 1) ? labels.general.submit : labels.general.continue}
                </button>
            </Box>
            
        </Box>
    </div>
    )
}

export default JobApplicationForm